export default __webpack_public_path__ + "static/media/2CroreTerm.ab3bd894.svg";